import {
  REQUEST_ACTION_ARCHIVE_ITEM,
  REQUEST_ACTION_ARCHIVE_MASS,
  REQUEST_ACTION_ASSIGN_ITEM,
  REQUEST_ACTION_ASSIGN_MASS,
  REQUEST_ACTION_CONNECT_DOC_FLOW_MASS,
  REQUEST_ACTION_CONNECT_SERVICE_REQUEST_ITEM,
  REQUEST_ACTION_CONNECT_SERVICE_REQUEST_MASS,
  REQUEST_ACTION_DUE_DATE_ITEM,
  REQUEST_ACTION_DUE_DATE_MASS,
  REQUEST_ACTION_EDIT_CATEGORY_ITEM,
  REQUEST_ACTION_EDIT_CATEGORY_MASS,
  REQUEST_ACTION_EDIT_LABEL_ITEM,
  REQUEST_ACTION_EDIT_LABEL_MASS,
  REQUEST_ACTION_EDIT_PROVIDER_ITEM,
  REQUEST_ACTION_EDIT_PROVIDER_MASS,
  REQUEST_ACTION_GROUP_SERVICE_REQUESTS_MASS,
  REQUEST_ACTION_MARK_AS_PRIVATE,
  REQUEST_ACTION_MARK_AS_PRIVATE_MASS,
  REQUEST_ACTION_MARK_AS_PUBLIC,
  REQUEST_ACTION_MARK_AS_PUBLIC_MASS,
  REQUEST_ACTION_MARK_AS_READ,
  REQUEST_ACTION_MARK_AS_READ_MASS,
  REQUEST_ACTION_MARK_AS_UNREAD,
  REQUEST_ACTION_MARK_AS_UNREAD_MASS,
  REQUEST_ACTION_RESTORE_ITEM,
  REQUEST_ACTION_RESTORE_MASS,
  REQUEST_ACTION_UPDATE_STATUS_ITEM,
  REQUEST_ACTION_UPDATE_STATUS_MASS,
} from './Request.constants.actions'

export function getNotificationTitle({ action, count, t, totalCount }) {
  const types = {
    [REQUEST_ACTION_ARCHIVE_ITEM]: t('Notification.CommonTitleArchivedKey'),
    [REQUEST_ACTION_ARCHIVE_MASS]: t(
      'Notification.CommonTitleMassArchivedKey',
      {
        count,
        totalCount,
      }
    ),
    [REQUEST_ACTION_ASSIGN_ITEM]: t('Notification.CommonTitleSavedKey'),
    [REQUEST_ACTION_ASSIGN_MASS]: t('Notification.CommonTitleMassSavedKey', {
      count,
      totalCount,
    }),
    [REQUEST_ACTION_CONNECT_DOC_FLOW_MASS]: t(
      'Notification.RequestTitleMassConnectDocFlowsKey',
      {
        count,
        totalCount,
      }
    ),
    [REQUEST_ACTION_CONNECT_SERVICE_REQUEST_ITEM]: t(
      'Notification.RequestTitleRequestsConnectedKey'
    ),
    [REQUEST_ACTION_CONNECT_SERVICE_REQUEST_MASS]: t(
      'Notification.RequestTitleMassRequestsConnectedKey',
      {
        count,
        totalCount,
      }
    ),
    [REQUEST_ACTION_DUE_DATE_ITEM]: t('Notification.CommonTitleSavedKey'),
    [REQUEST_ACTION_DUE_DATE_MASS]: t('Notification.CommonTitleMassSavedKey', {
      count,
      totalCount,
    }),
    [REQUEST_ACTION_EDIT_CATEGORY_ITEM]: t('Notification.CommonTitleSavedKey'),
    [REQUEST_ACTION_EDIT_CATEGORY_MASS]: t(
      'Notification.CommonTitleMassSavedKey',
      {
        count,
        totalCount,
      }
    ),
    [REQUEST_ACTION_EDIT_LABEL_ITEM]: t('Notification.CommonTitleSavedKey'),
    [REQUEST_ACTION_EDIT_LABEL_MASS]: t(
      'Notification.CommonTitleMassSavedKey',
      {
        count,
        totalCount,
      }
    ),
    [REQUEST_ACTION_EDIT_PROVIDER_ITEM]: t('Notification.CommonTitleSavedKey'),
    [REQUEST_ACTION_EDIT_PROVIDER_MASS]: t(
      'Notification.CommonTitleMassSavedKey',
      {
        count,
        totalCount,
      }
    ),
    [REQUEST_ACTION_GROUP_SERVICE_REQUESTS_MASS]: t(
      'Notification.RequestTitleMassGroupKey',
      {
        count,
        totalCount,
      }
    ),
    [REQUEST_ACTION_MARK_AS_PRIVATE]: t(
      'Notification.RequestTitleMarkAsPrivateKey'
    ),
    [REQUEST_ACTION_MARK_AS_PRIVATE_MASS]: t(
      'Notification.RequestTitleMassMarkAsPrivateKey',
      {
        count,
        totalCount,
      }
    ),
    [REQUEST_ACTION_MARK_AS_PUBLIC]: t(
      'Notification.RequestTitleMarkAsPublicKey'
    ),
    [REQUEST_ACTION_MARK_AS_PUBLIC_MASS]: t(
      'Notification.RequestTitleMassMarkAsPublicKey',
      {
        count,
        totalCount,
      }
    ),
    [REQUEST_ACTION_MARK_AS_READ]: t('Notification.RequestTitleMarkAsReadKey'),
    [REQUEST_ACTION_MARK_AS_READ_MASS]: t(
      'Notification.RequestTitleMassMarkAsReadKey',
      {
        count,
        totalCount,
      }
    ),
    [REQUEST_ACTION_MARK_AS_UNREAD]: t(
      'Notification.RequestTitleMarkAsUnreadKey'
    ),
    [REQUEST_ACTION_MARK_AS_UNREAD_MASS]: t(
      'Notification.RequestTitleMassMarkAsUnreadKey',
      {
        count,
        totalCount,
      }
    ),
    [REQUEST_ACTION_RESTORE_ITEM]: t('Notification.CommonTitleRestoredKey'),
    [REQUEST_ACTION_RESTORE_MASS]: t(
      'Notification.CommonTitleMassRestoredKey',
      {
        count,
        totalCount,
      }
    ),
    [REQUEST_ACTION_UPDATE_STATUS_ITEM]: t('Notification.CommonTitleSavedKey'),
    [REQUEST_ACTION_UPDATE_STATUS_MASS]: t(
      'Notification.CommonTitleMassSavedKey',
      {
        count,
        totalCount,
      }
    ),
  }

  return types[action] || null
}

export function getAsyncNotificationText({ action, t }) {
  const types = {
    [REQUEST_ACTION_ARCHIVE_MASS]: t(
      'Notification.RequestAsyncTextMassArchiveKey'
    ),
    [REQUEST_ACTION_ASSIGN_MASS]: t(
      'Notification.RequestAsyncTextMassAssignKey'
    ),
    [REQUEST_ACTION_CONNECT_DOC_FLOW_MASS]: t(
      'Notification.RequestAsyncTextMassConnectDocFlowsKey'
    ),
    [REQUEST_ACTION_CONNECT_SERVICE_REQUEST_MASS]: t(
      'Notification.RequestAsyncTextMassConnectRequestsKey'
    ),
    [REQUEST_ACTION_DUE_DATE_MASS]: t(
      'Notification.RequestAsyncTextMassChangeDueDateKey'
    ),
    [REQUEST_ACTION_EDIT_CATEGORY_MASS]: t(
      'Notification.RequestAsyncTextMassEditCategoryKey'
    ),
    [REQUEST_ACTION_EDIT_LABEL_MASS]: t(
      'Notification.RequestAsyncTextMassEditLabelKey'
    ),
    [REQUEST_ACTION_EDIT_PROVIDER_MASS]: t(
      'Notification.RequestAsyncTextMassChangeProviderKey'
    ),
    [REQUEST_ACTION_GROUP_SERVICE_REQUESTS_MASS]: t(
      'Notification.RequestAsyncTextMassGroupKey'
    ),
    [REQUEST_ACTION_MARK_AS_READ_MASS]: t(
      'Notification.RequestAsyncTextMassMarkAsReadKey'
    ),
    [REQUEST_ACTION_MARK_AS_UNREAD_MASS]: t(
      'Notification.RequestAsyncTextMassMarkAsUnreadKey'
    ),
    [REQUEST_ACTION_RESTORE_MASS]: t(
      'Notification.RequestAsyncTextMassRestoreKey'
    ),
    [REQUEST_ACTION_UPDATE_STATUS_MASS]: t(
      'Notification.RequestAsyncTextMassUpdateStatusKey'
    ),
  }

  return types[action] || null
}
